export default async function CreateSplitPlanApi(
  splitFrom,
  scaleId,
  scaleUnitId,
  title,
  planLevel,
  description,
  target,
  targetDate,
  assignTo,
  attributes,
  unitID,
  strategyId,
  cascadeFromSplitPlans,
  isPercentageUpdate,
  isNegativeScale
) {
  let res = "";
  try {
    const body = {
      splitFrom: splitFrom,
      scaleId: scaleId,
      scaleUnitId: scaleUnitId,
      title: title,
      planLevel: planLevel,
      description: description || "",
      target: target,
      targetDate: targetDate || "",
      assignTo: assignTo,
      attributes,
      unitId: unitID,
      strategyId: strategyId || null,
      cascadeFromSplitPlans: cascadeFromSplitPlans || false,
      isPercentageUpdate: isPercentageUpdate || false,
      isNegativeScale: isNegativeScale || false,
    };
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
      body: JSON.stringify(body),
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/plans/split-plan`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error create split plan: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }

  return res;
}
